<template>
  <el-tooltip :disabled="!needTooltip" placement="bottom" effect="light" transition="el-zoom-in-top" :open-delay="300">
    <p class="flex-grow-1" slot="content">
      {{ safeContent }}
    </p>
    <el-link
      v-if="isEmail"
      class="flex-grow-1"
      icon="el-icon-edit"
      type="primary"
      :underline="false"
      :href="`mailto:${plainText}`"
    >
      {{ safeContent }}
    </el-link>
    <p v-else-if="isRichtext" class="flex-grow-1" v-html="formattedContent" />
    <p v-else class="flex-grow-1">
      {{ formattedContent }}
    </p>
  </el-tooltip>
</template>

<script>
import { htmlToText } from '../../../utils/html-to-text'
import { MAX_CHARACTERS_IN_GRID_VIEW } from '../lib/list-constants'
import { sanitizeHTML } from '../../../utils/html-sanitizer'

export default {
  name: 'TextField',
  props: {
    content: {
      type: [String, Number],
    },
    type: {
      type: String,
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedContent() {
      return this.needTooltip ? this.truncated : this.safeContent
    },
    isEmail() {
      return this.type === 'email'
    },
    isRichtext() {
      return this.type === 'richtext'
    },
    needTooltip() {
      return !this.inDetailView && this.plainText.length > MAX_CHARACTERS_IN_GRID_VIEW
    },
    plainText() {
      return htmlToText(this.safeContent)
    },
    truncated() {
      return this.plainText.substring(0, MAX_CHARACTERS_IN_GRID_VIEW) + '...'
    },
    safeContent() {
      return sanitizeHTML(this.content)
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
  word-break: break-word;
}
</style>
